<template>
  <div class="home">
    <Navbar/>
    <!-- BANNER -->
    <div class="banner-home banner-anos-finais">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col text-center">
            <a href="http://www.editoradobrasil.com.br/faleconosco/" target="_blank" class="btn-duvidas" rel="noopener noreferrer">DÚVIDAS ? FALE CONOSCO</a>
          </div>
        </div>
        <div class="row justify-content-center btns-banner menu-md">
          <div class="col-md-10">
            <div class="row">
              <div class="col-md-6 text-center p-0">
                <router-link class="btn btn-branco" to="/anos-iniciais">Ensino Fundamental - Anos Iniciais</router-link>
              </div>
              <div class="col-md-6 text-center p-0">
                <router-link class="btn btn-azul" to="/anos-finais">Ensino Fundamental - Anos Finais</router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-md-8 p-0">
            <div class="text-banner final">
                A obra utiliza uma metodologia prática e objetiva, possibilitando o trabalho com estudantes sem conhecimentos prévios de finanças.
            </div>
          </div>
        </div>
        <div class="row justify-content-center btns-banner menu-sm">
          <div class="col-md-10">
            <div class="row">
              <div class="col-md-6 text-center p-0">
                <router-link class="btn btn-branco" to="/anos-iniciais">Ensino Fundamental - Anos Iniciais</router-link>
              </div>
              <div class="col-md-6 text-center p-0">
                <router-link class="btn btn-azul" to="/anos-finais">Ensino Fundamental - Anos Finais</router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-md-6">
            <div class="tudo">
              <div class="img-livro">
                <a href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/educacao-financeira/vu/index.html" target="_blank" rel="noopener noreferrer"><img src="../assets/livros/fin0.png" class="img-fluid mx-auto"></a>
              </div>
              <div class="fundo-livro">
                <img src="../assets/imagens/outras-imgs/bg-livro.png" class="img-fluid mx-auto">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- DESTAQUE -->
    <div class="container destaque">
      <div class="row justify-content-center">
        <div class="col-md-7 text-center">
          <h1 class="verde">Destaques da obra</h1>
          <img src="../assets/imagens/outras-imgs/destaques-da-obra.png" class="img-fluid dest-obra">
        </div>
      </div>
      <div class="row justify-content-center">
          <div class="col-md-9">
              <div class="row">
                <div class="col-md-6">
                    <div class="box-destaque">
                        <img src="../assets/imagens/destaques/anos-finais/1-ativadedes.png" class="img-fluid mx-auto">
                        <p>Traz atividades contextualizadas, fazendo com que o estudante aprenda utilizando como base situações do seu cotidiano.</p>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="box-destaque">
                        <img src="../assets/imagens/destaques/anos-finais/2-bncc.png" class="img-fluid mx-auto">
                        <p>Competências e habilidades da BNCC desenvolvidas por meio da leitura de textos, seguida de reflexão de atividades de pesquisa e da resolução de situações-problema.</p>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="box-destaque">
                        <img src="../assets/imagens/destaques/anos-finais/3-design.png" class="img-fluid mx-auto">
                        <p>Design gráfico agradável e moderno.</p>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="box-destaque">
                        <img src="../assets/imagens/destaques/anos-finais/4-disciplinas.png" class="img-fluid mx-auto">
                        <p>Abordagens interdisciplinares que possibilitam uma conexão de economia, matemática e outras disciplinas, potencializando o aprendizado.</p>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="box-destaque">
                        <img src="../assets/imagens/destaques/anos-finais/5-linguagens.png" class="img-fluid mx-auto">
                        <p>Linguagem simples e prática.</p>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="box-destaque">
                        <img src="../assets/imagens/destaques/anos-finais/6-material.png" class="img-fluid mx-auto">
                        <p>Material do professor em sintonia com a BNCC, trazendo orientações didáticas e respostas.</p>
                    </div>
                </div>
              </div>
          </div>
      </div>
    </div>
    <!-- AUTORES -->
    <div class="container autores">
      <div class="row justify-content-center">
        <div class="col-md-10 text-center">
          <h1>Autores</h1>
          <img src="../assets/imagens/autores.png" class="img-fluid mx-auto">
          <div class="texto">
            <p class="sub-titulo">Alex Sandro Marques</p>
            <p>• Graduando em Ciências Biológicas no Instituto de Biociências da Universidade Estadual Paulista (Unesp), Botucatu.</p>
            <p>• Autor de materiais didáticos.</p>
          </div>
          <div class="texto">
            <p class="sub-titulo">André Andere</p>
            <p>• Bacharel em Ciências Econômicas pela Universidade Estadual de Campinas - SP (Unicamp).</p>
            <p>• Licenciado em Matemática pela Universidade Polis das Artes.</p>
            <p>• MBA em Gestão Escolar pela Universidade de São Paulo (USP). </p>
            <p>• Atualmente professor no ensino fundamental: anos finais do colégio Poliedro (São José dos Campos e Campinas - SP).</p>
          </div>
          <!-- <div class="texto">
            <p class="sub-titulo">Angela Cruz</p>
            <p>• Bacharel e licenciada em História pela Universidade Federal do Rio de Janeiro (UFRJ).</p>
            <p>• Professora da História aposentada pelo Colégio Pedro II (RJ), da rede federal de ensino.</p>
            <p>• Coautora de obras didáticas sobre juventude e trabalho.</p>
          </div> -->
          <div class="texto">
            <p class="sub-titulo">Pollyana Santana Silva</p>
            <p>• Licenciada em Matemática pela Universidade Estadual Paulista (Unesp).</p>
            <p>• Mestre em Matemática pela Universidade Federal de São Paulo (Unifesp).</p>
            <p>• Atualmente professora de Matemática nos anos finais dos colégios Poliedro (São José dos Campos) e Univap (Jacareí).</p>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'Home',
  components: {
    Navbar,
    Footer
  }
}
</script>
